
import { fireDangerModelList, nfdrRadioButtons } from '../../../../constants';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { Typography } from '@mui/material';
import { useEffect } from 'react';
import { useChartTableSelect, useElementRadioSelect, useElementSelection, useWindDirection, useWindSpeed, useNfdrFuelModelSelected} from 'src/store/actions';
import { useStoreContext } from 'src/store/context';
import { useHistory, useLocation, } from 'react-router';
import { ROUTE_PATHS } from 'src/routes';
import FormControlLabel from '@mui/material/FormControlLabel';

import { ElementSelect } from 'src/types';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
import { buildPath } from 'src/store/common';

const NfdrSelect = ()=>{
    const [state, dispatch] = useStoreContext();
    const selectElement = useElementSelection(dispatch);
    const history = useHistory();
    const location = useLocation(); 
    const radioGlobalSet = useElementRadioSelect(dispatch);
    const selectChartTableType = useChartTableSelect(dispatch);
    const selectWindSpeed = useWindSpeed(dispatch);
    const selectWindDirection = useWindDirection(dispatch);
    const selectFuelModel = useNfdrFuelModelSelected(dispatch);

    /*update path as needed*/
    useEffect(()=>{
        if(location.search){
            const stringArray = decodeURIComponent(location.search).split("/");
            if (stringArray.length>=9) {
                const element = stringArray[2];
                const mapType = stringArray[0];
                const type = stringArray[1];
                const fm: string = stringArray[7];
                if(type!== state.selectedRadio.type || mapType!==state.selectedRadio.dataType){
                    const findRadio = nfdrRadioButtons.find((radioItem)=> radioItem.type === type);
                    if(findRadio){
                        radioGlobalSet(findRadio);
                    }
                }
                if(state.selectedElement?.value!==element){
                    const findWeatherValue = state.selectedRadio.elementSelections?.find((item:any)=> item?.value ===element);
                    if(findWeatherValue){
                        selectElement(findWeatherValue);
                    }
                }
                if(fm!== state.nfdrFuelModel){
                    selectFuelModel(fm)
                }
            }
            else{
                const paramsForBuildPath = {
                        dataType: state.mapDataType,
                        radio: state.selectedRadio.type,
                        element: state.selectedElement?.value,
                        zoom: state.currentZoom,
                        basemap: state.selectedBaseMap.id,
                        minElevation: state.elevationFilterValues[0],
                        maxElevation: state.elevationFilterValues[1],
                        windOrMethod: state.nfdrFuelModel,
                        windOrSub: false
                }
                buildPath(paramsForBuildPath, history);
            
            }
        }
        if(!location.search){
            if(sessionStorage.getItem('path')){
                const path = sessionStorage.getItem('path');
                if(path!==null){
                    history.push({pathname: `${ROUTE_PATHS.home}`, search: path});
                }
            }
            else{
                const paramsForBuildPath = {
                    dataType: state.mapDataType,
                    radio: state.selectedRadio.type,
                    element: state.selectedElement?.value,
                    zoom: state.currentZoom,
                    basemap: state.selectedBaseMap.id,
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.nfdrFuelModel,
                    windOrSub: false
                }
                buildPath(paramsForBuildPath, history);
            }
        }
        
    },[state.selectedElement, state.selectedBaseMap.id,
        location.search,selectElement, state.currentZoom, history, state.elevationFilterValues , radioGlobalSet,
        selectChartTableType, state.selectedRadio.elementSelections, state.selectedRadio.type, selectWindDirection, selectWindSpeed,
        state.wind_direction, state.wind_speed,state.mapDataType, state.selectedRadio.dataType, state.nfdrFuelModel,
        selectFuelModel
    ]);
    
    const handleFuelModelSelect = (fuelModel: any)=>{
        selectFuelModel(fuelModel)                
        const paramsForBuildPath = {
            dataType: state.mapDataType,
            radio: state.selectedRadio.type,
            element: state.selectedElement.value,
            zoom: state.currentZoom,
            basemap: state.selectedBaseMap.id,
            minElevation: state.elevationFilterValues[0],
            maxElevation: state.elevationFilterValues[1],
            windOrMethod: fuelModel,
            windOrSub: false
        }
        buildPath(paramsForBuildPath, history);;
    }

    const handleElementSelect =(elementSelect:any, radio?:any)=>{    
        if(radio){
            const findNFDRValue = radio.elementSelections.find((item: ElementSelect)=> item.value ===elementSelect);
            if(findNFDRValue){
                selectElement(findNFDRValue);
                const paramsForBuildPath = {
                    dataType: state.mapDataType,
                    radio: radio.type,
                    element: findNFDRValue.value,
                    zoom: state.currentZoom,
                    basemap: state.selectedBaseMap.id,
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.nfdrFuelModel,
                    windOrSub: false
                }
                buildPath(paramsForBuildPath, history);
                selectChartTableType(findNFDRValue.defaultChart);
            }

        }
        else{
            const findNFDRValue = state.selectedRadio.elementSelections.find((item: ElementSelect)=> item.value ===elementSelect);
            if(findNFDRValue){
                selectElement(findNFDRValue);
                const paramsForBuildPath = {
                    dataType: state.mapDataType,
                    radio: state.selectedRadio.type,
                    element: findNFDRValue.value,
                    zoom: state.currentZoom,
                    basemap: state.selectedBaseMap.id,
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.nfdrFuelModel,
                    windOrSub: false
                }
                buildPath(paramsForBuildPath, history);
                selectChartTableType(findNFDRValue.defaultChart)
            }
        }

    };
    const handleRadioSelect = (radio: any) => {
        const prevRadio = state.selectedRadio;
        const findRadio = nfdrRadioButtons.find((radioItem) => radioItem.type === radio);
        if (findRadio) {
            radioGlobalSet(findRadio);
            if (prevRadio !== radio) {
                handleElementSelect(findRadio.elementSelections[findRadio.elementSelections.length-2].value, findRadio)
            }
            else {
                const paramsForBuildPath = {
                    dataType: state.mapDataType,
                    radio: findRadio.type,
                    element: state.selectedElement?.value,
                    zoom: state.currentZoom,
                    basemap: state.selectedBaseMap.id,
                    minElevation: state.elevationFilterValues[0],
                    maxElevation: state.elevationFilterValues[1],
                    windOrMethod: state.nfdrFuelModel,
                    windOrSub: false
                }
                buildPath(paramsForBuildPath, history);
            }
        }
    }

    return(
        <div>
            <div>
                <label style={{ fontSize: 'small', marginTop: '2px', marginBottom: '1px', height: '2rem', fontWeight: 'bold'}}>FUEL MODEL
                    <Select
                        value={state.nfdrFuelModel ? state.nfdrFuelModel: ''}
                        onChange={(event) => handleFuelModelSelect(event.target?.value)}
                        id="fuelModel"
                        style={{ fontSize: 'small', width: '63%', marginTop: '2px', marginBottom: '1px', height: '2rem', marginLeft:'3px' }}
                        className="select-styles"
                        inputProps={{
                            id: 'fuelModel',
                        }}
                    >
                        {fireDangerModelList.map((fm: string) => (
                            <MenuItem value={fm} key={`${fm}`}>
                                {fm}
                            </MenuItem>
                        ))}
                    </Select>
                </label>
            </div>
            <div>
                <FormControl>
                    <RadioGroup
                        id="firedangerData"
                        style={{marginLeft: '10px'}}
                        name="controlled-radio-buttons-group"
                        value={state.selectedRadio.type}
                        onChange={(event) => { handleRadioSelect(event.target?.value); }}
                    >
                        {nfdrRadioButtons.map((radioItem: any) =>
                            <FormControlLabel
                                key={`${radioItem.type}`}
                                value={radioItem.type}
                                control={<Radio size='small' style={{ padding: '5px' }} />}
                                label={<Typography style={{ fontSize: '.7rem' }}>{radioItem.label}</Typography>}
                            />
                        )}
                    </RadioGroup>
                </FormControl>
            </div>
            <div>
                <label style={{ fontSize: 'small', width: '20%', marginTop: '2px', marginBottom: '1px', height: '2rem',fontWeight: 'bold' }}> NFDRS OUTPUT
                    <Select
                        value={state.selectedElement ? state.selectedElement.value : ''}
                        onChange={(event) => handleElementSelect(event.target?.value)}
                        id="nfdrData"
                        style={{ fontSize: 'small', width: '63%', marginTop: '2px', marginBottom: '1px', height: '2rem', marginLeft:'3px' }}
                        className="select-styles"
                        inputProps={{
                            id: 'nfdrData',
                        }}
                    >
                        {state.selectedRadio.elementSelections.map((element: any) => (
                            <MenuItem value={element.value} key={`${element.value}`}>
                                {element.label}
                            </MenuItem>
                        ))}
                    </Select>
                </label>
            </div>
        </div>
    )
}
export default NfdrSelect;